export default "__VITE_ASSET__b525c074__"